import React from "react";
import Fonts from "../../../../Config/Fonts";
import Icons from "../../../../Config/Images";
import Colors from "../../../../theme/Colors";
import { productStatus } from "../../../../Constants/AppConstants";

const ProductTableBody = ({
  products,
  onEditProductDetails,
  onViewProductDetails,
  handleShowDeleteModal,
  onViewBtnShow,
  onEditBtnShow,
  onDeleteBtnShow,
}) => {

  return (
    <tbody>
      {products?.map((prod, index) => {
        const stockStatus =
          prod?.product_quantity > 1
            ? productStatus.IN_STOCK
            : productStatus.OUT_OF_STOCK;

        return (
          <tr key={index}>
            <td style={tableDataInputStyle}>{index + 1}</td>
            <td align="left" style={tableDataInputStyle}>
              {prod?.product_name}
            </td>
            <td align="left" style={tableDataInputStyle}>
              {prod?.product_category_name}
            </td>
            <td align="left" style={tableDataInputStyle}>
              {"-"}
            </td>
            <td align="left" style={tableDataInputStyle}>
              {prod?.product_metal_name || "-"}
            </td>
            <td align="left" style={tableDataInputStyle}>
              {prod?.product_name || "Nil"}
            </td>
            <td align="left" style={tableDataInputStyle}>
              {"-"}
            </td>
            <td align="left" style={tableDataInputStyle}>
              {prod?.product_quantity}
            </td>
            <td align="left" style={tableDataInputStyle}>
              <div
                style={{
                  color: stockStatus.color || "#e0e0e0",
                  padding: "5px 10px",
                  borderRadius: "4px",
                  textAlign: "center",
                }}
              >
                {stockStatus.label || "Unknown"}
              </div>
            </td>
            <td align="center" style={tableDataInputStyle}>
              {onViewBtnShow && (
                <img
                  src={Icons.viewIcon}
                  style={{ height: "15px", width: "15px", cursor: "pointer" }}
                  onClick={() => onViewProductDetails(prod)}
                  alt="Preview Icon"
                />
              )}
              {onEditBtnShow && (
                <img
                  src={Icons.editIcon}
                  style={{
                    height: "15px",
                    width: "15px",
                    cursor: "pointer",
                    marginLeft: "15px",
                  }}
                  onClick={() => onEditProductDetails(prod)}
                  alt="Edit Icon"
                />
              )}
              {onDeleteBtnShow && (
                <img
                  src={Icons.trashIcon}
                  style={{
                    height: "15px",
                    width: "15px",
                    cursor: "pointer",
                    marginLeft: "15px",
                  }}
                  onClick={() => handleShowDeleteModal(prod?.product_id)}
                  alt="Delete Icon"
                />
              )}
            </td>
          </tr>
        );
      })}
    </tbody>
  );
};

const tableDataInputStyle = {
  fontSize: 12,
  fontWeight: 500,
  fontFamily: Fonts.Poppins,
  color: Colors.black,
  textAlign: "center",
  padding: "8px 10px",
  border: "1px solid #E6E6E6",
};

export default ProductTableBody;
